import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import {
    ENVIAR_SAT_MORA,
    ENVIAR_SAT_MASIVO_MORA,
    ERROR_AUTORIZACION,
    ERROR_ENVIO_MORA_INDIVIDUAL,
    ERROR_ENVIO_MORA_MASIVO,
    ENVIO_EXITOSO_MORA,
    ENVIO_EXITOSO_MORA_MASIVO,
    DESCARGAR_PLANTILLA_MASIVO_MORA,
    PLANTILLA_MORA_OBTENIDA,
    ERROR_OBTENIENDO_PLANTILLA_MORA,
    LIMPIAR_MENSAJES_MORA,
    errorAutorizacion,
    errorEnvioMoraIndividual,
    errorEnvioMoraMasivo,
    envioMoraExito,
    envioMoraMasivoExito,
    plantillaMoraObtenida,
    errorObteniendoPlantillaMora
} from "../modulos/procesarMoraActions";

export const enviarSATMoraEpic = action$ =>
    action$.ofType(ENVIAR_SAT_MORA)
        .mergeMap((action: any) => {

            const url = `sat/mora/envio-individual`;

            return authenticatedAjax
                .post(
                    url,
                    action.datosEnvioMora,
                    { 'Content-Type': 'application/json', 'proceso': 'REPORTE_MORA' }
                )
                .map(response => {
                    const respuesta = response.response.datos;
                    return envioMoraExito(respuesta.poliza, respuesta.dni, respuesta.consecutivoMoraNota);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioMoraIndividual(mensajeRespuesta)];
                    }
                });
        });

export const enviarSATMasivoMoraEpic = action$ =>
    action$.ofType(ENVIAR_SAT_MASIVO_MORA)
        .mergeMap((action: any) => {

            const url = `sat/mora/envio-masivo`;

            return authenticatedAjax
                .upload(
                    url,
                    action.archivoEnvioMora, {}, { 'proceso': 'REPORTE_MORA' }
                )
                .map((response) => {
                    return envioMoraMasivoExito(response.response.datos.consecutivoMoraNota);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioMoraMasivo(mensajeRespuesta)];
                    }
                });
        });

export const descargarPlantillaMasivoMoraEpic = action$ =>
    action$.ofType(DESCARGAR_PLANTILLA_MASIVO_MORA)
        .mergeMap((action: any) => {

            const url = `sat/descargas/plantilla-mora`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        "plantilla_masivo_reporte_mora.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return plantillaMoraObtenida();
                }).catch(response =>
                    [errorObteniendoPlantillaMora()]
                );
        });

export const envioMoraReducer = (state =
    {
        estadoEnvio: REQUEST.NONE,
        mensajeUsuario: undefined,
        poliza: undefined,
        dni: undefined,
        consecutivoMoraNota: undefined
    }, action: AnyAction) => {

    switch (action.type) {

        case ENVIAR_SAT_MORA:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.PENDING,
                estadoEnvioMasivo: REQUEST.NONE
            };
        case ENVIAR_SAT_MASIVO_MORA:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.PENDING
            };
        case ENVIO_EXITOSO_MORA:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.SUCCESS,
                estadoEnvioMasivo: REQUEST.NONE,
                poliza: action.poliza,
                dni: action.dni,
                consecutivoMoraNota: action.consecutivoMoraNota
            };
        case ENVIO_EXITOSO_MORA_MASIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.SUCCESS,
                estadoEnvioIndividual: REQUEST.NONE,
                consecutivoMoraNota: action.consecutivoMoraNota
            };
        case ERROR_AUTORIZACION:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.FORBIDDEN,
                estadoEnvioMasivo: REQUEST.FORBIDDEN
            };
        case ERROR_ENVIO_MORA_INDIVIDUAL:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case ERROR_ENVIO_MORA_MASIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case LIMPIAR_MENSAJES_MORA:
            return {
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.NONE,
                poliza: undefined,
                dni: undefined,
                mensajeUsuario: undefined
            };
        case PLANTILLA_MORA_OBTENIDA:
        case ERROR_OBTENIENDO_PLANTILLA_MORA:
            return { ...state };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_mora/modulos/procesaMoraReducers.ts